import axios from "axios";
import { Service } from "axios-middleware";
// Vuex Store
import store from "../store";

const service = new Service(axios);

// let accessToken = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6IllNRUxIVDBndmIwbXhvU0RvWWZvbWpxZmpZVSJ9.eyJhdWQiOiI0ODc2MjQ5OS05NmFhLTQ2NTUtODRjYS00YTA5ZjJkNGFlZWEiLCJpc3MiOiJodHRwczovL2xvZ2luLm1pY3Jvc29mdG9ubGluZS5jb20vZDM5YjMwMTgtNjg4Zi00ZDBkLTlmY2UtOGMzY2IxMTY5YzIxL3YyLjAiLCJpYXQiOjE1ODczNTQ2MjEsIm5iZiI6MTU4NzM1NDYyMSwiZXhwIjoxNTg3MzU4NTIxLCJhaW8iOiJBVFFBeS84UEFBQUFSWWo0QXhod1MwVG9td21yRHN4ZlZUYzhzRzdXME9WeFNjWGNKUmYrbDJkamZLZTMxd1g1aUx2MFM0U1RISmFBIiwiYXpwIjoiNDg3NjI0OTktOTZhYS00NjU1LTg0Y2EtNGEwOWYyZDRhZWVhIiwiYXpwYWNyIjoiMCIsIm5hbWUiOiJOYXR0YXBhdCBXb25nd2FyYW5na3VsIiwib2lkIjoiMDE1MzdjZWMtOTMzZS00Yjg0LTk0ZGUtY2M0ZDc4ZDBjM2U5IiwicHJlZmVycmVkX3VzZXJuYW1lIjoibmF0dGFwYXQud29AZ3VsZi5jby50aCIsInNjcCI6IndlYnJlYWQiLCJzdWIiOiJITHpYdXgza2VMWWFncm5tQnI4V1FIZ3ZVUnlqWXZRWjlucXJZOUJtdG1vIiwidGlkIjoiZDM5YjMwMTgtNjg4Zi00ZDBkLTlmY2UtOGMzY2IxMTY5YzIxIiwidXRpIjoiRzB6SlVnV21aVVNwM0tiS1pDTXJBQSIsInZlciI6IjIuMCJ9.KAqXdU0dWlAbRuJxydNUg_-r_MR974wR_vgwV6SLQQUvnGVGO9Ej1Qoat7J5IJIDX6S-1ylMdV09b06qLPkoi9i3MdsptXxjmNILpCU0LWNWeRvWGu1ddb71ul_cETVoODm4q6zp7wnEqSKCZQRWVG6ziGZkYT3YzPrlQ5l8Jo_w7-hbgsKOnh3TH4XMxuZCDLtj5V5Rl7sJpJGLB0hBvDuGh7sf0X0CD6gi13utKPzpeCSOWqUbt6CYG3RgavZo6ROXqVVS89JctY0TByKC2FnTdLSnPHc_Di7v9-K0EUwnY4fu1bJx5VpiCRLNcLDnY4Ik4YAKouu11psGi46nSw";
let token = `Bearer ${localStorage.getItem("token")}`;

// console.log(`Bearer ${msal}`);

service.register({
  onRequest(config) {
    if (token) config.headers.Authorization = token;

    return config;
  },
  onSync(promise) {
    // console.log('onSync');
    return promise;
  },
  onResponse(response) {
    // console.log("onResponse", response);
    return response;
  },
  onResponseError(err) {
    // console.log("###### error request ###### " + err);
    console.log("Error message", err.response.status);

    if (err.response.status == 401) {
      store.dispatch("logout");
      window.location.href = "/vendor";
    }
    // if (err.response === 401 && err.config && !err.config.hasRetriedRequest) {
    /* if (err == "Error: Request failed with status code 401") {
      console.log("####");
      store.dispatch("logout");

    } */
    throw err;
  },
});

export default axios.create({
  baseURL: process.env.VUE_APP_API,
  responseType: "json",
});
